/**
 * Converts an ArrayBuffer (from Graph photo endpoint) to a base64 data URI.
 *
 * Why chunked? Spreading a large Uint8Array directly into String.fromCharCode(...)
 * causes "Maximum call stack size exceeded" on WKWebView (Mac Outlook).
 * Processing in 8KB chunks avoids this.
 *
 * @param buffer - Raw image bytes from GET /me/photo/$value
 * @param mimeType - MIME type of the image (Graph returns JPEG)
 */
export function arrayBufferToBase64DataUri(buffer, mimeType = "image/jpeg") {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    const chunkSize = 8192;
    for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode(...chunk);
    }
    return `data:${mimeType};base64,${btoa(binary)}`;
}
/**
 * Generates an SVG initials avatar as a base64 data URI.
 * Used as a fallback when the user has no Entra profile photo.
 *
 * The resulting data URI is safe to embed in email HTML — it's a
 * self-contained encoded SVG, not an external URL.
 *
 * @param displayName - Full name, e.g. "Jane Smith" → initials "JS"
 * @param bgColor - Background circle color (default: Microsoft blue)
 */
export function generateInitialsAvatarDataUri(displayName, bgColor = "#0078d4") {
    const initials = displayName
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join("");
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
  <circle cx="48" cy="48" r="48" fill="${bgColor}"/>
  <text
    x="50%" y="50%"
    dominant-baseline="central"
    text-anchor="middle"
    font-family="Arial, Helvetica, sans-serif"
    font-size="38"
    font-weight="bold"
    fill="#ffffff"
  >${initials}</text>
</svg>`;
    return `data:image/svg+xml;base64,${btoa(svg)}`;
}
